export const CheckIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14.414" height="10.145" viewBox="0 0 14.414 10.145">
            <path id="Icon_feather-check" data-name="Icon feather-check" d="M19,9l-8.937,8.938L6,13.875"
                  transform="translate(-5.293 -8.293)" fill="none" stroke="#000" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1"/>
        </svg>
    )
}
